import { customDispatch } from "@affinity/Store/ServiceBase";
import { createHandlerChainRunner, Handler, HasOnComplete } from "@insite/client-framework/HandlerCreator";
import logger from "@insite/client-framework/Logger";
import { getBillTo, updateBillTo, UpdateBillToApiParameter } from "@insite/client-framework/Services/CustomersService";
import { BillToModel, ShipToCollectionModel, ShipToModel } from "@insite/client-framework/Types/ApiModels";

// External parameters
interface UpdatePreferenceParameters {
    billToId: string,
    confirmedMarketing: boolean;
    confirmedTermsAndConditions: boolean;
}

interface Props {
    billTo: BillToModel,
    billToResult: BillToModel, // For debugging purposes
}

type Parameter = UpdatePreferenceParameters & HasOnComplete<Props>;

type HandlerType = Handler<Parameter, Props>;

export const UpdatePreferences: HandlerType = async props => {
    // call shared code
    // just to external sales service or also cache in commerce system so can review later?
    // link to review later?

    if (props.parameter.billToId) {
        try {
            props.billTo = await getBillTo({ billToId: props.parameter.billToId })

            const updatedBillTo: BillToModel = {
                ...props.billTo,
            };

            // Custom Property Add
            updatedBillTo.properties = {
                ...props.billTo.properties,
                consentMarketing: props.parameter.confirmedMarketing.toString()
            };

            const billToApiParameter: UpdateBillToApiParameter = {
                billTo: updatedBillTo
            }
            props.billToResult = await updateBillTo(billToApiParameter);
        } catch (error) {
            logger.error("Create Account: Unable to update marketing preferences", error);
        }
    }
}

export const UpdateState: HandlerType = props => {
    (props.dispatch as customDispatch)({
        type: "Affinity/CreateAccount/SetComplete",
        // TO DO Add a content managed target URL on the Affinity create account page
        targetUrl: "/createaccount/thankyou",
    });
}

const FireOnComplete: HandlerType = props => {
    if (props.billTo) {
        props.parameter.onComplete?.({ billTo: props.billTo, billToResult: props.billToResult });
    }
}

export const Tracking: HandlerType = props => {
    //
}

export const chain = [
    UpdatePreferences,
    UpdateState,
    FireOnComplete,
    Tracking,
];

const updateAccountPreferences = createHandlerChainRunner(chain, "UpdateAccountPreferences");
export default updateAccountPreferences;
